import React, { useState, useEffect, useCallback, useMemo } from "react";
import DataTable from "react-data-table-component";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import Popup from "../common/popup";
import Sidebar from "../common/sidebar/index";
import CommonAlert from "../common/Commonalert";
import moment from "moment";
import { http } from "../helper";
import EditAccountDetails from "./editAccountdetail";
import { Link, Navigate } from "react-router-dom";
import { BaseUrl } from "../common/config";
import {capitalizeFirstLetter, dateformatwithuktime } from "../utilityfunctions";
import { canAction } from "../common/permissionhelper";
import { useTranslation } from "react-i18next";

const Account = (props) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [accountData, setAccountData] = useState([]);
  const [searchTextVal, setSearchTextVal] = useState("");
  const [templist, setTemplist] = useState([]);
  const [editaccDet, setEditaccDet] = useState(false);
  const [accounDet, setAccounDet] = useState("");
  const [loading, setLoading] = useState(true);
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [editProdDet, setEditProdDet] = useState();
  const [roleName] = useState(
    JSON.parse(sessionStorage.getItem("authData"))
      ? JSON.parse(sessionStorage.getItem("authData")).adminRole.roleName
      : "",
  );
  const [rolePermissions] = useState(
    JSON.parse(sessionStorage.getItem("authData"))
      ? JSON.parse(sessionStorage.getItem("authData")).adminRole.permissions
      : "",
  );

  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";

  const activateTab = useCallback((index) => {
    setActiveTab((prev) => (prev === index ? -1 : index));
  }, []);

  const getAccounts = useCallback(() => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    let URL = BaseUrl + "admin/all";
    http
      .get(URL)
      .then((response) => {
        if (rolePermissions.includes("manage_users")) {
          setAccountData(response.data.data);
          setTemplist(response.data.data);
          setLoading(false);
        } else {
          const accdata = response.data.data.filter(
            (acc) => acc.adminEmail === loginDetails.adminEmail,
          );
          setAccountData(accdata);
          setTemplist(accdata);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [rolePermissions]);

  const toggleModel = useCallback(() => {
    setVisible((prev) => !prev);
  }, []);

  const editAccountDetails = useCallback((accoun) => {
    setEditaccDet(true);
    setAccounDet(accoun);
  }, []);

  const editclosepopup = useCallback((alrtpopup, alrtmsg) => {
    setEditaccDet(false);
    setAlertPopup(alrtpopup);
    setAlertMessage(alrtmsg);
  }, []);

  const editAccDetails = useCallback((formData) => {
    let URL = BaseUrl + "admin/editadminaccount/" + formData.id;
    setEditProdDet(false);
    setLoading(true);
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    http
      .put(URL, formData)
      .then((response) => {
        let responseData = response.data.success;
        if (responseData) {
          setAlertPopup(true);
          setAlertMessage(t("account_details_updated_success_txt"));
          setLoading(false);
        }
        setEditaccDet(false);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    document.body.classList.add("split");
    getAccounts();
  }, [getAccounts]);

  const addUser = useCallback(() => {
    window.location.href = "/account/adduser";
  }, []);

  const handleReset = useCallback(() => {
    setSearchTextVal("");
    setAccountData(templist);
  }, [templist]);

  const filterData = useCallback(
    async (value) => {
      let accoun = templist;
      const lowercasedValue = value.toLowerCase().trim();
      let result = [];
      if (lowercasedValue.length > 0) {
        accoun.map((item) => {
          if (
            item.adminName.toString().toLowerCase().includes(lowercasedValue) ||
            item.adminEmail
              .toString()
              .toLowerCase()
              .includes(lowercasedValue) ||
            item.adminRole.roleName
              .toString()
              .toLowerCase()
              .includes(lowercasedValue)
          ) {
            result.push(item);
          }
        });
        setAccountData(result);
      } else {
        setAccountData(accoun);
      }
    },
    [templist],
  );

  const handleChange = useCallback(
    async (value) => {
      setSearchTextVal(value);
      filterData(value);
    },
    [filterData],
  );

  const columns = useMemo(() => {
    const cols = [
      {
        name: t("name_txt"),
        selector: (row) => row.adminName,
        sortable: true,
      },
      {
        name: t("email_address_txt"),
        selector: (row) => row.adminEmail,
        sortable: true,
      },
      {
        name: t("status_txt"),
        selector: (row) => capitalizeFirstLetter(row.adminStatus),
        sortable: true,
      },
      {
        name: t("role_name_txt"),
        selector: (row) => row.adminRole.roleName,
        sortable: true,
      },
      {
        name: t("created_on_txt"),
        selector: (row) => dateformatwithuktime(row.createdAt),
        sortable: true,
      },
      {
        name: t("modified_on_txt"),
        selector: (row) => dateformatwithuktime(row.updatedAt),
        sortable: true,
      },
    ];
    // Conditionally add the Actions column if the user has 'manage_users' permission
    if (
      rolePermissions.includes("manage_users") ||
      cols.some((col) =>
        col.selector({
          adminEmail: JSON.parse(sessionStorage.getItem("authData")).adminEmail,
        }),
      )
    ) {
      cols.push({
        name: t("actions_txt"),
        selector: (row, index) => {
          const canEdit = canAction("manage_users", "edit");
          return (
            <div style={{ display: "flex" }}>
              <a
                className="button title-tooltip title-up"
                data-title={canEdit ? t("edit_txt") : t("view_txt")}
                style={{ color: "white" }}
                onClick={() => editAccountDetails(row)}
              >
                <i
                  className={`fa ${canEdit ? "fa-pencil" : "fa-eye"}`}
                  aria-hidden="true"
                ></i>
              </a>
            </div>
          );
        },
        sortable: false,
      });
    }
    return cols;
  }, [rolePermissions, editAccountDetails]);

  const customStyles = useMemo(
    () => ({
      rows: {
        style: {
          minHeight: "25px",
        },
      },
      headCells: {
        style: {
          paddingLeft: "8px", // override the cell padding for head cells
          paddingRight: "8px",
        },
      },
      cells: {
        style: {
          paddingLeft: "8px", // override the cell padding for data cells
          paddingRight: "8px",
        },
      },
    }),
    [],
  );

  const { panels } = props;

  return (
    <>
      {alertPopup == true && (
        <CommonAlert title={t("alert_txt")} message={alertMessage} />
      )}
      <div className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <section className="cart-block">
            <div className="container">
              <h1 className="checkout-title">{t("user_txt")}</h1>
              <div className="right-table-outer-wrap">
                <div className="table-filter search-orders">
                  <div className="table-search-reset">
                    <div className="table-search">
                      <input
                        type="text"
                        value={searchTextVal}
                        onChange={(e) => handleChange(e.target.value)}
                        className="form-control"
                        placeholder={t("search_by_role_email_name_txt")}
                      />
                    </div>
                    <button
                      className="submitbtn button search-holi-btn"
                      onClick={(e) => filterData(searchTextVal)}
                    >
                      <i className="fa fa-search"></i>
                    </button>
                    <button
                      className="resetbtn"
                      type="reset"
                      onClick={handleReset}
                    >
                      {t("reset_txt")}
                    </button>
                  </div>
                  {canAction("manage_users", "add") && (
                    <div className="add-userbtn">
                      <button className="addbtn" onClick={addUser}>
                        <i className="fa fa-plus"></i> {t("add_user_txt")}{" "}
                      </button>
                    </div>
                  )}
                </div>
                <div className="table_overflow admin-account-table">
                  <DataTable
                    columns={columns}
                    noDataComponent={
                      <div className="no-records-found">
                        {t("no_data_in_user_txt")}
                      </div>
                    }
                    data={accountData}
                    customStyles={customStyles}
                    progressPending={loading}
                  />
                </div>
              </div>
            </div>
          </section>
          <Footer />
        </div>
        {editaccDet && (
          <EditAccountDetails
            editAccdet={accounDet}
            editloading={loading}
            popupclose={editclosepopup}
            editAccounDetails={editAccDetails}
          />
        )}
        {visible ? (
          <>
            <Popup
              title={t("admin_user_txt")}
              closebtn={
                <>
                  <span
                    onClick={() => setVisible(false)}
                    className="close"
                  ></span>
                </>
              }
              bodyMoreTxt={
                <>
                  <div className="pro-form">
                    <div className="pro-row">
                      <label>
                        {t("first_name_txt")} <span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={t("enter_first_name_txt")}
                      />
                    </div>
                    <div className="pro-row">
                      <label>
                        {t("last_name_txt")}<span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={t("enter_last_name_txt")}
                      />
                    </div>
                    <div className="pro-row">
                      <label>
                        {t("email_address_txt")}<span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={t("enter_email_address_txt")}
                      />
                    </div>
                    <div className="pro-row">
                      <label>
                        {t("contact_number_txt")}<span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={t("enter_contact_num_txt")}
                      />
                    </div>
                    <div className="pro-row">
                      <label>
                        {t("user_name_txt")}<span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={t("enter_username_txt")}
                      />
                    </div>
                    <div className="pro-row">
                      <label>
                        {t("password_txt")}<span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={t("enter_password_txt")}
                      />
                    </div>
                    <div className="pro-row">
                      <label>
                        {t("retype_pasword_txt")}<span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={t("enter_password_txt")}
                      />
                    </div>
                    <div className="pro-row">
                      <label>
                        {t("status_txt")}<span>*</span>
                      </label>
                      <select className="form-control">
                        <option>{t("active_txt")}</option>
                        <option>{t("inactive_txt")}</option>
                      </select>
                    </div>
                    <div className="pro-row flx-bottom">
                      <button title={t("submit_txt")} className="light-btn button">{t("submit_txt")}</button>
                      <button
                        title={t("cancel_txt")}
                        onClick={() => setVisible(false)}
                        className="dark-btn button"
                      >
                        {t("cancel_txt")}
                      </button>
                    </div>
                  </div>
                </>
              }
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default React.memo(Account);
